module.exports = __webpack_public_path__ + "img/answer_error.ed384d33.png";